import styled from 'styled-components/macro'
import Box from 'components/shared/Box'

interface LegendBadgeCustomProps {
    color: string
    hasDarkMode?: boolean
}

export const LegendBadgeCustom = styled(Box)<LegendBadgeCustomProps>`
    position: relative;
    min-height: 12px;

    &::before,
    &::after {
        content: '';
        position: absolute;
        z-index: 0;
        background-color: ${({ color }) => color};
        border-radius: 15px;
    }

    &::before {
        left: 0;
        top: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
        opacity: ${({ hasDarkMode }) => (hasDarkMode ? 0.4 : 0.1)};
    }
    &::after {
        left: 3px;
        top: 3px;
        z-index: 1;
        width: 6px;
        height: 6px;
    }
`

export const LegendBadgeGeneric = styled(Box)`
    position: relative;
    width: 5px;
    height: 5px;
    box-sizing: content-box;
    border-radius: 50%;
    background: transparent;
    border: 4px solid transparent;

    &::after {
        content: '';
        position: absolute;
        z-index: 0;
        background-color: ${({ theme }) => theme.colors.primary_500};
        border-radius: 15px;
        left: 0;
        top: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
    }
`
